import { useState } from 'react';
import { useMutation } from 'urql';
import PageHeader from '../../../components/PageHeader.jsx';
import StickyActions from '../../../components/StickyActions.jsx';
import { Field } from '../../../components/Field.jsx';
import { AJUSTAR_STOCK } from './gql.js';

export default function KardexAdjustForm({ productoId: initialProductoId = '', onCancel, onSaved }) {
  const [errors, setErrors] = useState({});
  const [formState, setFormState] = useState({
    productoId: initialProductoId,
    sucursalId: '',
    cantidad: '',
    motivo: '',
    usuario: '',
  });
  const [, ajustarStock] = useMutation(AJUSTAR_STOCK);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const nextErrors = {};
    if (!formState.productoId.trim()) {
      nextErrors.productoId = 'Indicá el producto a ajustar.';
    }
    if (!formState.sucursalId.trim()) {
      nextErrors.sucursalId = 'Indicá la sucursal.';
    }
    if (!formState.cantidad || Number(formState.cantidad) === 0) {
      nextErrors.cantidad = 'La cantidad debe ser distinta de cero.';
    }
    if (!formState.motivo.trim()) {
      nextErrors.motivo = 'El motivo es obligatorio.';
    }
    if (!formState.usuario.trim()) {
      nextErrors.usuario = 'El usuario es obligatorio.';
    }
    if (Object.keys(nextErrors).length) {
      setErrors(nextErrors);
      return;
    }

    try {
      await ajustarStock({
        productoId: formState.productoId.trim(),
        sucursalId: formState.sucursalId.trim(),
        cantidad: Number(formState.cantidad),
        motivo: formState.motivo.trim(),
        usuario: formState.usuario.trim(),
      });
      onSaved?.();
    } catch (error) {
      setErrors({ form: error.message });
    }
  };

  return (
    <form onSubmit={handleSubmit} className="mx-auto flex w-full max-w-[1400px] flex-col gap-6 px-6 py-8">
      <PageHeader
        title="Ajustar stock"
        subtitle="Registrá un ajuste manual que impactará en el Kardex y en el stock valuado."
      />

      {errors.form ? (
        <div className="rounded-2xl border border-red-500/40 bg-red-500/10 px-4 py-3 text-sm text-red-200">{errors.form}</div>
      ) : null}

      <section className="rounded-2xl border border-[rgb(var(--border))] bg-[rgba(var(--panel),0.7)] p-6 shadow-sm">
        <div className="grid grid-cols-12 gap-4">
          <Field label="Producto" hint={errors.productoId}>
            <input
              value={formState.productoId}
              onChange={(event) => setFormState((prev) => ({ ...prev, productoId: event.target.value }))}
              className="w-full rounded-xl border border-[rgb(var(--border))] bg-[rgba(var(--bg),0.85)] px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
            />
          </Field>
          <Field label="Sucursal" hint={errors.sucursalId}>
            <input
              value={formState.sucursalId}
              onChange={(event) => setFormState((prev) => ({ ...prev, sucursalId: event.target.value }))}
              className="w-full rounded-xl border border-[rgb(var(--border))] bg-[rgba(var(--bg),0.85)] px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
            />
          </Field>
          <Field label="Cantidad" hint={errors.cantidad}>
            <input
              type="number"
              step="0.01"
              value={formState.cantidad}
              onChange={(event) => setFormState((prev) => ({ ...prev, cantidad: event.target.value }))}
              className="w-full rounded-xl border border-[rgb(var(--border))] bg-[rgba(var(--bg),0.85)] px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
            />
          </Field>
          <Field label="Usuario" hint={errors.usuario}>
            <input
              value={formState.usuario}
              onChange={(event) => setFormState((prev) => ({ ...prev, usuario: event.target.value }))}
              className="w-full rounded-xl border border-[rgb(var(--border))] bg-[rgba(var(--bg),0.85)] px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
            />
          </Field>
          <Field label="Motivo" hint={errors.motivo} className="col-span-12">
            <textarea
              value={formState.motivo}
              onChange={(event) => setFormState((prev) => ({ ...prev, motivo: event.target.value }))}
              rows={3}
              className="w-full rounded-xl border border-[rgb(var(--border))] bg-[rgba(var(--bg),0.85)] px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
            />
          </Field>
        </div>
      </section>

      <StickyActions
        left={
          <button
            type="button"
            onClick={onCancel}
            className="rounded-xl border border-[rgb(var(--border))] bg-transparent px-4 py-2 text-sm font-medium text-[rgb(var(--fg))] transition hover:bg-[rgba(var(--fg),0.05)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
          >
            Cancelar
          </button>
        }
        right={
          <button
            type="submit"
            className="rounded-xl bg-[rgb(var(--brand))] px-6 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-[rgba(var(--brand-700),0.9)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
          >
            Confirmar ajuste
          </button>
        }
      />
    </form>
  );
}
